import React, { useState } from 'react';
import { Download, Filter, Calendar } from 'lucide-react';
import { importService } from '../../../services/importService';

const ExportPanel = ({ advisorId, leads }) => {
  const [filters, setFilters] = useState({
    stage: '',
    fuente: '',
    dateFrom: '',
    dateTo: ''
  });
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    try {
      setExporting(true);
      await importService?.exportLeads({
        advisorId,
        ...filters
      });
    } catch (error) {
      console.error('Export failed:', error);
    } finally {
      setExporting(false);
    }
  };

  const filteredCount = leads?.filter(lead => {
    if (filters?.stage && lead?.stage !== filters?.stage) return false;
    if (filters?.fuente && lead?.fuente !== filters?.fuente) return false;
    if (filters?.dateFrom && new Date(lead?.createdAt) < new Date(filters?.dateFrom)) return false;
    if (filters?.dateTo && new Date(lead?.createdAt) > new Date(filters?.dateTo)) return false;
    return true;
  })?.length;

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-900 mb-6">Export Leads</h2>
      <div className="bg-gray-50 rounded-lg p-6 mb-6">
        <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <Filter className="w-5 h-5" />
          Export Filters
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Stage</label>
            <select
              value={filters?.stage}
              onChange={(e) => setFilters({ ...filters, stage: e?.target?.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">All Stages</option>
              <option value="new">New</option>
              <option value="contacted">Contacted</option>
              <option value="qualified">Qualified</option>
              <option value="proposal">Proposal</option>
              <option value="negotiation">Negotiation</option>
              <option value="closed_won">Closed Won</option>
              <option value="closed_lost">Closed Lost</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Source</label>
            <select
              value={filters?.fuente}
              onChange={(e) => setFilters({ ...filters, fuente: e?.target?.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">All Sources</option>
              <option value="referral">Referral</option>
              <option value="website">Website</option>
              <option value="social_media">Social Media</option>
              <option value="direct">Direct</option>
              <option value="event">Event</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <Calendar className="w-4 h-4 inline mr-1" />
              Date From
            </label>
            <input
              type="date"
              value={filters?.dateFrom}
              onChange={(e) => setFilters({ ...filters, dateFrom: e?.target?.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <Calendar className="w-4 h-4 inline mr-1" />
              Date To
            </label>
            <input
              type="date"
              value={filters?.dateTo}
              onChange={(e) => setFilters({ ...filters, dateTo: e?.target?.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
        <h3 className="font-semibold text-gray-900 mb-2">Export Summary</h3>
        <p className="text-gray-700">
          You are about to export <span className="font-bold text-blue-600">{filteredCount}</span> leads
          {filters?.stage && <span> with stage <span className="font-semibold">{filters?.stage}</span></span>}
          {filters?.fuente && <span> from source <span className="font-semibold">{filters?.fuente}</span></span>}
        </p>
      </div>
      <div className="flex gap-4">
        <button
          onClick={handleExport}
          disabled={exporting || filteredCount === 0}
          className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center gap-2"
        >
          {exporting ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              Exporting...
            </>
          ) : (
            <>
              <Download className="w-5 h-5" />
              Export to CSV
            </>
          )}
        </button>

        <button
          onClick={() => setFilters({ stage: '', fuente: '', dateFrom: '', dateTo: '' })}
          className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default ExportPanel;